import ErrorBoundary from '@ui/error-boundary/error-boundary';
import { Suspense, lazy } from 'react';

const _Icons = lazy(() => import('./icon-wrapped'));

interface Props {
  name: string;
  size?: number; // replaces width + height in the svg. If you use actual width/height from figma the icon is too small. Take the larger
  // of width + height and use that as the size param
  viewBox?: string;
  backgroundColor?: string;
  color?: string;
}

export const SvgLemonadeGradient = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <defs>
        <linearGradient
          id="svg_lemonade_gradient"
          x1="0"
          y1="22"
          x2="12.0004"
          y2="1.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFD62" />
          <stop offset="1" stopColor="#FF6AE6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default function Icon(props: Props): JSX.Element {
  return (
    <Suspense fallback="">
      <ErrorBoundary>
        <_Icons {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
